export default __webpack_public_path__ + "static/media/15.fd499d4b.png";